import TravelInfo from './TravelInfo';

export default TravelInfo;
